import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import About from '../../components/about/about';
import Testimonial from '../../components/Testimonial/Testimonial';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';


const AboutPage = () => {
    return (
        <Fragment>
            <Navbar hclass={'header-style-1'}/>
            <PageTitle pageTitle={'About Us'}/>
            <About abClass={'about-pg-about-section'}/>
            <Testimonial tClass={'about-pg-testimonials-section'} />
            <CtaSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default AboutPage;
